module.exports = __webpack_public_path__ + "static/img/flow-thumb.237fe71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/features/flow-thumb.png
// module id = 1Tqt
// module chunks = 6